import { Map, MapDataset, MapPrivacy } from 'features/maps/types'
import { Connection } from 'features/connections/types'
import { BuilderMode } from '../types'
import { User, UserRole } from 'features/users'

export function shouldRequireViewerCredentials({
  builderMode,
  map: currentMap
}: {
  builderMode: BuilderMode
  map: Map
}) {
  if (
    builderMode === BuilderMode.Public ||
    (builderMode === BuilderMode.Viewer && currentMap.privacy === MapPrivacy.Public)
  ) {
    return false
  }
  return true
}

export function shouldRequireViewerCredentialsForGuest(currentMapDatasets: MapDataset[], user?: User) {
  const isGuest = user?.app_metadata?.roles?.includes(UserRole.Guest) || false
  if (
    isGuest &&
    currentMapDatasets.some((dataset) => dataset.connectionViewerCredentials && dataset.connectionName !== 'carto_dw')
  ) {
    return true
  }
  return false
}

export function connectionRequiresViewerCredentials(connection: Connection) {
  return !connection.carto_dw && connection.viewerCredentials
}

export function isConnectionMissingViewerCredentials(connection: Connection) {
  return connectionRequiresViewerCredentials(connection) && !connection.viewerCredentialsAttached
}

export function getConnectionsWithViewerCredentials(mapDatasets: MapDataset[], connections: Connection[]) {
  const connectionsId = mapDatasets.map((dataset) => dataset.connectionId)
  return connections.filter(
    (connection) => connectionRequiresViewerCredentials(connection) && connectionsId.includes(connection.id)
  )
}

export function getConnectionsWithMissingViewerCredentials(mapDatasets: MapDataset[], connections: Connection[]) {
  return getConnectionsWithViewerCredentials(mapDatasets, connections).filter((conn) => !conn.viewerCredentialsAttached)
}
